import React, { useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import { CommonCss } from "../../services/CommonCss";
import { HeaderCommonCss } from "./HeaderCss";
import { Box } from "@material-ui/core";
import clsx from "clsx";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import DialogTitle from '@material-ui/core/DialogTitle';
const useStyles = makeStyles((theme) => ({
  subMenuInnerMenu: {
    position: "static",
    "& .subMenuInnerMenuList": {
      display: "none",
      position: "absolute",
      top: 0,
      left: "21%",
      borderLeft: "1px solid #f0f0f0",
      height: "240px",
      zIndex: 12,
    },
    "&:hover .subMenuInnerMenuList": {
      display: "block",
      color: "#fff !important",
    },
    "&:hover .subMenuInnerMenuList li a": {
      color: "#fff !important",
    },
    "&:hover a,& .subMenuInnerMenuList li a:hover": {
      color: "#FF4717 !important",
    },
  },
  ulBox: {
    position: "static",
    paddingTop: "18px",
    paddingBottom: "18px",
  },
  innerMenuItemBoxInline: {
    padding: "0 !important",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight:"8px"
  },
  btnStyle1: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ff4717",
    background: "#fff !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight:"8px"
  },
  subMenuInnerMenuList: {
    "& ul": {
      paddingTop: "18px",
      paddingBottom: "18px",
      paddingLeft: "12px",
      height: "100%",
    },
    "&.servicesInnerMenuTab ul": {
      paddingTop: "60px",
    },
  },
}));

export default function MenuWhatwedo(props) {
  const commonClasses = CommonCss();
  const headerClasses = HeaderCommonCss();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openUrl, setOpenUrl] = React.useState("");
  const handleClickOpen = (url) => {
    if(props.username){
      setOpenUrl(url);
      setOpen(true);
    } else {
      window.location = process.env.REACT_APP_PUBLIC_URL+url;
    }
  };
  
  const handleClose = (status) => {
    if(status){
      window.location = process.env.REACT_APP_PUBLIC_URL+openUrl;
    } 
    setOpen(false);
    setOpenUrl("");
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={()=>{handleClose(false)}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
         <div className="link-popup">
        <HighlightOffIcon onClick={()=>{handleClose(false)}} />
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <DialogContent>
        <Box
                component="img"
        
                display="block"
                margin="auto"
                className={" warning"}
                pb={1}  
               src={process.env.REACT_APP_CUSTOMER_PORTAL_URL +"assets/svg/Warning.svg"}
               />
        <DialogContentText id="alert-dialog-description">
          You are about to leave this page. You can come back by clicking the on Customer portal link under the 
          Customer Icon  <Box
           pl={1}  
                component="img" 
               src={process.env.REACT_APP_CUSTOMER_PORTAL_URL +"assets/svg/customer-new.svg"} 
               />

   </DialogContentText>
          <DialogContentText id="alert-dialog-description">
          Are you sure you want to continue to the website?
          </DialogContentText>
        </DialogContent>
        <DialogActions
        className="button-center custpop1"
        display="flex"
        justifyContent="center"
        alignItems="center"
        justifyContent="center"
        >
          <Button   onClick = {
            () => {
              handleClose(false)
            }
          }
          className = "btn-style1" >
          Cancel
          </Button>
          <Button onClick={()=>{handleClose(true)}}  className={ classes.btnStyle2}>
          Continue 
          </Button>
        </DialogActions>
        </div>
      </Dialog>
      <Box
        position="fixed"
        component="section"
        className={clsx(
          headerClasses.innerMenuItemBox,
          classes.innerMenuItemBoxInline,
          "innerMenuItemBox"
        )}
        width={1}
        p={0}
        left="0"
      >
        <Box className={commonClasses.navContainer}>
          <Box>
            <List className={classes.ulBox}>
              <ListItem
                className={clsx(classes.subMenuInnerMenu, "subMenuInnerMenu")}
              >
                <Box
                  component="a"
                  //href={process.env.REACT_APP_PUBLIC_URL + "Sectors.html"}
                  onClick={()=>{handleClickOpen("Sectors.html")}}
                >
                  Sectors
                </Box>
                <Box
                  className={clsx(
                    classes.subMenuInnerMenuList,
                    "subMenuInnerMenuList"
                  )}
                >
                  <List>
                    <ListItem>
                      <Box
                        component="a"
                        //href={process.env.REACT_APP_PUBLIC_URL + "marine.html"}
                        onClick={()=>{handleClickOpen("marine.html")}}
                      >
                        Marine
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box
                        component="a"
                       // href={process.env.REACT_APP_PUBLIC_URL + "power.html"}
                       onClick={()=>{handleClickOpen('power.html')}}
                      >
                        Power
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box
                        component="a"
                        
                        onClick={()=>{handleClickOpen('Renewables.html')}}
                      >
                        Renewables
                      </Box>
                    </ListItem>
                  </List>
                </Box>
              </ListItem>
              <ListItem
                className={clsx(classes.subMenuInnerMenu, "subMenuInnerMenu")}
              >
                <Box
                  component="a"
                  //href={process.env.REACT_APP_PUBLIC_URL + "services.html"}
                  onClick={()=>{handleClickOpen('services.html')}}
                >
                  Services
                </Box>
                <Box
                  className={clsx(
                    classes.subMenuInnerMenuList,
                    "servicesInnerMenuTab",
                    "subMenuInnerMenuList"
                  )}
                >
                  <List>
                    <ListItem>
                      <Box
                        component="a"
                        
                        onClick={()=>{handleClickOpen('services-FQT.html')}}
                      >
                        Fuel Quality Testing
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box
                        component="a"
                        
                        onClick={()=>{handleClickOpen('services-BQS.html')}}
                      >
                        Bunker Quantity Surveys
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box
                        component="a"
                        
                        onClick={()=>{handleClickOpen('services-OCM.html')}}
                      >
                        Oil Condition Monitoring
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box
                        component="a"
                        
                        onClick={()=>{handleClickOpen('services-TOT.html')}}
                      >
                        Transformer Oil Testing
                      </Box>
                    </ListItem>
                  </List>
                </Box>
              </ListItem>
              <ListItem>
                <Box
                  component="a"
                  
                  onClick={()=>{handleClickOpen('innovation-section-whatwedo.html')}}
                >
                  Innovation
                </Box>
              </ListItem>
              <ListItem>
                <Box
                  component="a"
                  
                  onClick={()=>{handleClickOpen('analyics-whatwedo.html')}}
                >
                  Analytics
                </Box>
              </ListItem>
              <ListItem>
                <Box
                  component="a"
                  
                  onClick={()=>{handleClickOpen('what-we-do.html#Emissions')}}
                >
                  Emissions Reduction
                </Box>
              </ListItem>
            </List>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
